// headerTheme.js - Shared visual constants for the redesigned header
// (bar, nav pills, contextual sub-tab row, dropdown menus).

export const HEADER = {
  brand: "#0077b6",
  brandDeep: "#00669c",
  onBrand: "#ffffff",
  // Inactive labels on the brand blue render at full white, not a dimmed
  // opacity: 80% white on #0077b6 is 3.7:1 contrast, below WCAG AA (4.5:1).
  // Hierarchy between active/inactive comes from fill and font weight instead.
  onBrandInactive: "#ffffff",
  onBrandHover: "rgba(255,255,255,0.14)",
  brandLine: "rgba(255,255,255,0.22)",
  amber: "#f59e0b",
  amberInk: "#1f1300",
  danger: "#dc2626",
  initialsBg: "#e0f2fe",
  barHeight: 52,
  subBarHeight: 38,
  tabHeight: 36,
  iconSize: 20,
  labelSize: 14,
};

export const MENU_LIGHT = {
  bg: "#ffffff",
  text: "#10233a",
  muted: "#5b6b7d",
  line: "#e3eaf2",
  hover: "#eef4fa",
};

export const MENU_DARK = {
  bg: "#1e293b",
  text: "#f1f5f9",
  muted: "#94a3b8",
  line: "#2e3d55",
  hover: "#273449",
};

export const menuColors = (isDarkMode) => (isDarkMode ? MENU_DARK : MENU_LIGHT);

// "Bipin Dama" -> "BD", "Ana" -> "A", "  " / null -> "?"
export const initialsFor = (name) => {
  if (!name || typeof name !== "string") return "?";

  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";

  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

  return initials || "?";
};
